import { render, staticRenderFns } from "./evaluate_student.vue?vue&type=template&id=2e181ae2"
import script from "./evaluate_student.vue?vue&type=script&lang=js"
export * from "./evaluate_student.vue?vue&type=script&lang=js"
import style0 from "./evaluate_student.vue?vue&type=style&index=0&id=2e181ae2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports